<template>
  <div>
    <div v-for="(data, index) in contentList" :key="`content_${index}`">
      <div v-for="(page, pageIndex) in totalPages(data.content)" :key="`page_${pageIndex}`" class="print-break-page">
        <!--      상단부-->
        <table>
          <colgroup>
            <col width="160" />
            <col />
            <col width="160" />
            <col />
          </colgroup>
          <tr>
            <td colspan="4">
              <h1>교육 날인부</h1>
              <p class="mb-2">({{ contentDate(data.content) }})</p>
            </td>
          </tr>
          <tr>
            <th>교육명</th>
            <td><p>{{ contentName(data.content) }}</p></td>
            <th>교육시간</th>
            <td><p>{{ contentTime(data.content) }}</p></td>
          </tr>
          <tr>
            <th>교육장소</th>
            <td><p>{{ contentPlace(data.content) }}</p></td>
            <th>팀(업체)명</th>
            <td><p>{{ contentCompany(data.content) }}</p></td>
          </tr>
        </table>

        <!--      하단부-->
        <div class="flex mt-4 gap-2 member-table">
          <table>
            <colgroup>
              <col width="40" />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tr>
              <th>No.</th>
              <th>소속</th>
              <th>직책</th>
              <th>성명</th>
              <th>날인</th>
            </tr>
            <tr v-for="(member, memberIndex) in 20" :key="`member_${memberIndex}`">
              <td><span>{{ getMemberIndex(pageIndex, memberIndex) + 1 }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)].소속 : '' }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)].직책 : '' }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)].이름 : '' }}</span></td>
              <td><img v-if="data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)]" :src="data.content.참석자명단[getMemberIndex(pageIndex, memberIndex)].서명" style="height: 20px;"/></td>
            </tr>
          </table>

          <table>
            <colgroup>
              <col width="40" />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tr>
              <th>No.</th>
              <th>소속</th>
              <th>직책</th>
              <th>성명</th>
              <th>날인</th>
            </tr>
            <tr v-for="(member, memberIndex) in 20" :key="`member_${memberIndex}`">
              <td><span>{{ getMemberIndex(pageIndex, memberIndex + 20) + 1 }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)].소속 : '' }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)].직책 : '' }}</span></td>
              <td><span>{{ data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)]? data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)].이름 : '' }}</span></td>
              <td><img v-if="data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)]" :src="data.content.참석자명단[getMemberIndex(pageIndex, memberIndex + 20)].서명" style="height: 20px;" /></td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "PrintMember",
  props: {
    value: Array,
    board: Object,
  },
  computed: {
    contentList: {
      get() {
        console.log('value', this.value)
        return this.value || [];
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    formatTime(time) {
      if (!time) {
        return '';
      }

      try {
        const momentTime = moment(time, ['HH:mm:ss', 'HH:mm']);
        return momentTime.isValid() ? momentTime.format('HH:mm') : '';
      } catch {
        return '';
      }
    },

    formatDate(date) {
      if (!date) {
        return '';
      }

      const momentDate = moment(date);
      return momentDate.isValid() ? momentDate.format('YYYY년MM월DD일') : '';
    },

    totalPages(content) {
      if (content.참석자명단.length === 0) {
        return 1;
      }
      return Math.ceil(content.참석자명단.length / 40);
    },

    getMemberIndex(pageIndex, memberIndex) {
      return (pageIndex * 40) + memberIndex;
    },

    contentDate(content) {
      if (content && content.교육진행 && content.교육진행.length > 0) {
        const date = content.교육진행[0].교육일자;
        return date ? this.formatDate(date) : '';
      }
      return '';
    },

    contentName(content) {
      if (content && content.교육진행 && content.교육진행.length > 0) {
        return content.교육진행[0].교육명 || '';
      }
      return '';
    },

    contentTime(content) {
      if (!content || !content.교육진행 || !content.교육진행.length) {
        return '';
      }

      const 교육시간 = content.교육진행[0].교육시간;
      if (!교육시간) {
        return '';
      }

      const sTime = this.formatTime(교육시간.work_stime || '');
      const eTime = this.formatTime(교육시간.work_etime || '');

      if (!sTime && !eTime) {
        return '';
      }

      return `${sTime} ~ ${eTime}`;
    },

    contentPlace(content) {
      if (content && content.교육진행 && content.교육진행.length > 0) {
        return content.교육진행[0].교육장소 || '';
      }
      return '';
    },

    contentCompany(content) {
      const list = []
      if (content && content.팀업체) {
        for (const company of content.팀업체) {
          if (company && company.팀1차 && company.팀1차.value) {
            if (company.팀1차.value === "직접입력") {
              list.push(company.팀커스텀)
            } else {
              list.push(company.팀1차.value)
            }
          }
        }
      }
      return list.join(', ');
    },


  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th, td {
    border: solid 1px #cdcdcd;
    padding: 4px;

    h1 {
      font-weight: bold;
      text-align: center;
      padding: 10px 0 10px;
    }

    p {
      font-size: 10px;
      line-height: 1;
      text-align: center;
    }
  }

  th {
    background-color: #ECECEC;
    text-align: center;
    height: 40px;
  }

  thead {
    td {
      text-align: center
    }
  }
  tbody {
    td {
      text-align: start;
    }
  }
}

.member-table {
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    tr {
      display: table-row;
    }

    th, td {
      border: solid 1px #cdcdcd;
      text-align: center;
      padding: 2px;
      vertical-align: middle;
    }

    th {
      height: 38px;
      background-color: #ECECEC;
    }

    td {
      height: 39px;
    }
  }
}

.member-table td span {
  display: block;  /* 블록 요소로 설정 */
  line-height: 1;  /* 줄간격 최소화 */
  font-size: 10px;  /* 글자 크기 유지 */
  white-space: normal; /* 줄바꿈 허용 */
  margin: 0;  /* 마진 제거 */
  padding: 0; /* 패딩 제거 */
}

.bottom-line {
  padding-bottom: 1rem;
  border-bottom: 1px solid #cdcdcd;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px
}

.inline-border {
  width: 100%;
  border-collapse: collapse;
  border: solid 1px #cdcdcd;
  padding: 20px;
}

.print-break-page {
  page-break-after: always;
}

//.print-break-page:nth-child(n+2) {
//  margin-top: 55px !important;  /* 2페이지 이후 여백 추가 */
//}

.print-break-page:last-child {
  page-break-after: auto !important;  /* 마지막 페이지에서는 페이지 나누기 방지 */
}
</style>

